var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"commune-group-item"},[_c('div',{staticClass:"letter"},[_c('span',{staticClass:"heading-6"},[_vm._v(" "+_vm._s(_vm.communeGroup.letter.toUpperCase())+" ")])]),_c('div',{staticClass:"communes-group-container pt-2 d-flex flex-column"},_vm._l((_vm.communeGroup.items),function(item,key){return _c(item.isOutOfService ? 'span' : 'router-link',{key:key,tag:"RouterLink",staticClass:"pt-2 body-2",class:item.isOutOfService ? 'textSecondary--text' : 'secondary--text',attrs:{"to":{
        name: 'Commune',
        params: {
          name: item.slug,
        },
      }}},[_vm._v(" "+_vm._s(item.title)+" "+_vm._s(item.isOutOfService ? '(not-provide)' : '')+" ")])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }